(() => {
  const init = (root) => {
    root.querySelectorAll('[data-hmu-home]').forEach((home) => {
      if (home.dataset.hmuReady) return;
      home.dataset.hmuReady = 'true';
      const cards = home.querySelector('.hmu-cards');
      const controls = home.querySelector('.hmu-slider-controls');
      const previous = home.querySelector('[data-hmu-prev]');
      const next = home.querySelector('[data-hmu-next]');
      if (!cards || !controls) return;
      const update = () => {
        controls.hidden = cards.scrollWidth <= cards.clientWidth + 2;
        previous.disabled = cards.scrollLeft <= 2;
        next.disabled = cards.scrollLeft >= cards.scrollWidth - cards.clientWidth - 2;
      };
      const move = (direction) => {
        const card = cards.querySelector('.hmu-card');
        const distance = card ? card.getBoundingClientRect().width + 16 : cards.clientWidth;
        cards.scrollBy({ left: direction * distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      cards.addEventListener('scroll', update, { passive: true });
      cards.addEventListener('keydown', (event) => {
        if (event.target !== cards) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }
      });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
